import { Injectable } from "@angular/core";
import { CVCertificate, CvCertificateResponse } from "@data/cvCertificate";
import { ServiceResponse } from "@data/response";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { ResponseHandler } from "@service/system/responseHandler.service";
import { Observable } from "rxjs";

const API_URL = API.API_URL;

@Injectable()
export class CVCertificatesService {
	private _cvcertificatesURL = `${API_URL}/course`;

	constructor(private httpManager: HttpManager, private responseHandler: ResponseHandler) {}

	DeleteCVCertificate(cvItemID: string, cvCertificateItemID: string): Observable<any> {
		return this.httpManager.httpDelete<any>(
			`${this._cvcertificatesURL}/${cvItemID}/certificate/${cvCertificateItemID}/delete`
		);
	}

	GetCvCertificateByCvItemID(cvItemID: string): Observable<ServiceResponse<CVCertificate[]>> {
		return this.responseHandler.httpGet<CVCertificate[]>(`${this._cvcertificatesURL}/${cvItemID}/certificates`);
	}

	SetCvCertificate(cvItemID: string, body: string): Observable<ServiceResponse<CvCertificateResponse[]>> {
		return this.responseHandler.httpPost<CvCertificateResponse[]>(
			`${this._cvcertificatesURL}/${cvItemID}/certificate/set`,
			body
		);
	}
}
